import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {BehaviorSubject} from 'rxjs';
import {flatMap, UIArtefakt, UiInputControl} from '../../../models/uiArtefakt';
import {ThemeService} from '@lv1871/core';

export class SpeichernDialogInput {
  artefakte: UIArtefakt[];
}

@Component({
    selector: 'lv-speichern-dialog',
    templateUrl: './speichern-dialog.component.html',
    styleUrls: ['./speichern-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SpeichernDialogComponent implements OnInit {

  public showSpinner$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(public dialogRef: MatDialogRef<SpeichernDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: SpeichernDialogInput, private _themeService: ThemeService) {

  }

  ngOnInit(): void {
    this._themeService.setApplicationTheme(
        this._themeService.getThemeColor('lv-antragsannahme', '--lv-core-color-primary'),
        this._themeService.getThemeColor('lv-antragsannahme', '--lv-core-color-secondary'),
        this._themeService.getThemeColor('lv-antragsannahme', '--lv-core-color-warn'), null,
        'mdc-dialog__container'
    );
  }

  valuesMissing(): boolean {
    return !!flatMap(this.data.artefakte).filter(artefakt => !!(artefakt as UiInputControl).PflichtfeldJN && !artefakt.WertEingabe).length;
  }

  public closeDialog(): void {
    this.dialogRef.close(false);
  }

  public save() {
    this.dialogRef.close(true);
  }
}
